import { GlLink, GlAlert } from '@gitlab/ui';
import { glSlotsMixin } from '~/lib/utils/vue3compat/gl_slots_mixin';
export default {
    name: 'MRWidgetAlertMessage',
    components: {
        GlAlert,
        GlLink
    },
    mixins: [
        glSlotsMixin
    ],
    props: {
        type: {
            type: String,
            required: true
        },
        helpPath: {
            type: String,
            required: false,
            default: undefined
        },
        dismissible: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    data () {
        return {
            isDismissed: false
        };
    },
    methods: {
        onDismiss () {
            this.isDismissed = true;
        }
    }
};
